module.exports = __webpack_public_path__ + "img/کلاسیک.9231e738.png";